// extracted by mini-css-extract-plugin
export default {"leftBorder":"space-hierarchy_leftBorder__i9oIx","d-arrow":"space-hierarchy_d-arrow__8Hdrx"};